import {
  getIndividialDataFromAirtable,
  makeGroupedGlossaryList,
  RequestAPI,
} from '@learningblocks/exp-constants/lib/Utilities';

// const BASE_URL = 'https://api.learningsandbox.com';
const BASE_URL = 'https://api.airtable.com/v0/appsJDi2s5AKLyf5z/Glossary%20Data';
const GLOSSARY = 'glossary';

const inclusionList = [3, 43, 44, 45, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115 ]
const request = new RequestAPI(BASE_URL);

/**
 * Async function to fetch details of a particular content item using API
 */
// export function getContentDetailss(idString) {
//   return new Promise((resolve, reject) => {
//     request
//       .get(`${GLOSSARY}/${idString}`)
//       .then((response) => resolve(response))
//       .catch((error) => reject(error));
//   });
// }

export function getContentDetails(idString) {
  return getIndividialDataFromAirtable(BASE_URL, 'keyHsJP9sCMpQ1uhK', idString);
}


export function getIndividualGlossaryItem(fetchData, url, apiKey) {
  console.log('calling getIndividualGlossaryItem: ', url, apiKey);
  return (glossaryId) => {
    return new Promise(async (resolve, reject) => {
      let dataItem = await fetchData(url, apiKey, glossaryId);
      resolve(dataItem);
    });
  };
}
  
/**
 * Async function to fetch list of glossary Item using API
 */
export function getContentList(params) {
  return new Promise((resolve, reject) => {
    request
      .get(`${GLOSSARY}/?${makeQueryString(params)}`)
      .then((response) => resolve(makeGroupedGlossaryList(response, inclusionList)))
      .catch((error) => reject(error));
  });
}

/**
 * Function to make queryparams for glossarylist fetch api
 */
function makeQueryString(params) {
  let queryString = '';
  for (let key of Object.keys(params)) {
    queryString += `${key}=${params[key]}&`;
  }
  return queryString;
}
